import React from 'react';
import './ListBox.less';
import classNames from 'classnames';

interface IListBoxEmptyMessageProps {
  text?: string;
  list?: any[];
  className?: string;
}

const getClassName = (className?: string) => classNames(className, 'dpc-list-box__placeholder');

/**
 * No data readout for lists of things, chiefly a `ListBox`, though could also be used
 * in other places, such as a `CheckListEditor`
 *
 * Copyright (c) 2020 Decisions All Rights Reserved
 */
export function ListBoxEmptyMessage({ className, text, list }: IListBoxEmptyMessageProps) {
  return !list || list.length === 0 ? (
    <div className={getClassName(className)}>
      <div className={`dpc-list-box__placeholder-text`}>{text || '[ no data ]'}</div>
    </div>
  ) : null;
}
